import { CoreApiVersionPath, RosaCoreApiService } from '@/rosa';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { ClassificationNodeId } from '../../../interfaces/Classification.interface';
import type { ReportGenerationType, ReportPlan, ReportPlanId, RequestPlanCreationBody, RequestPlanUpdateBody } from '../reports.interface';

@Injectable({
    providedIn: 'root'
})
export class AdvizeoCoreReportsService {
    private _rosaCoreApiService = inject(RosaCoreApiService);

    generateReportOneShot$(
        period: number,
        enableEstimated: boolean,
        type: string,
        classificationNodeId: ClassificationNodeId,
        branding: string,
        generationType: ReportGenerationType
    ): Observable<string> {
        return this._rosaCoreApiService.get(
            `${CoreApiVersionPath.V3}reports/generate?period=${period}&type=${type}&classificationNodeId=${classificationNodeId}&branding=${branding}&enableEstimated=${enableEstimated}&generationType=${generationType}`
        );
    }

    createReportPlan$(request: RequestPlanCreationBody): Observable<void> {
        return this._rosaCoreApiService.post(`${CoreApiVersionPath.V3}reports/plans`, request);
    }

    updateReportPlan$(request: RequestPlanUpdateBody): Observable<void> {
        return this._rosaCoreApiService.put(`${CoreApiVersionPath.V3}reports/plans/${request.reportPlanId}`, request);
    }

    addReportSubscription$(reportPlanId: ReportPlanId, email: string): Observable<void> {
        return this._rosaCoreApiService.post(`${CoreApiVersionPath.V3}reports/plans/${reportPlanId}/subscriptions/${email}`, {});
    }

    deleteReportSubscription$(reportPlanId: ReportPlanId, email: string): Observable<void> {
        return this._rosaCoreApiService.delete(`${CoreApiVersionPath.V3}reports/plans/${reportPlanId}/subscriptions/${email}`, {});
    }

    fetchReportsPlans$(isSubscriber: boolean, isCreator: boolean, searchOnAdminScope: boolean): Observable<ReportPlan[]> {
        return this._rosaCoreApiService.post(`${CoreApiVersionPath.V3}reports/plans/search`, {
            isSubscriber,
            isCreator,
            searchOnAdminScope
        });
    }

    deleteReportPlan$(reportPlanId: ReportPlanId): Observable<void> {
        return this._rosaCoreApiService.delete(`${CoreApiVersionPath.V3}reports/plans/${reportPlanId}`);
    }

    updateSubscriptionStatus$(reportPlanId: ReportPlanId, isActive: boolean): Observable<void> {
        return this._rosaCoreApiService.patch(`${CoreApiVersionPath.V3}reports/plans/${reportPlanId}/subscriptions/status`, { isActive });
    }

    updateRecipientSubscriptionStatus$(reportPlanId: ReportPlanId, recipientEmail: string, isActive: Boolean): Observable<void> {
        return this._rosaCoreApiService.patch(
            `${CoreApiVersionPath.V3}reports/plans/${reportPlanId}/subscriptions/${recipientEmail}/isActive`,
            { isActive }
        );
    }
}
